import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Gift, Wallet } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";

const eur = (n) => `€${Number(n || 0).toFixed(2)}`;

export function CouponQr({ credit, testid }) {
  const [src, setSrc] = useState(null);
  useEffect(() => { QRCode.toDataURL(credit.coupon_code, { width: 220, margin: 1 }).then(setSrc); }, [credit.coupon_code]);
  return (
    <div className={`flex flex-col items-center p-2 rounded-xl border bg-white ${credit.reversed ? "opacity-40" : ""}`} data-testid={testid || `walkin-coupon-${credit.coupon_code}`}>
      {src && <img src={src} alt={credit.coupon_code} className="w-44 h-44" />}
      <p className="font-mono font-bold text-[#1e3a5f] tracking-widest">{credit.coupon_code}</p>
      <p className="text-xs text-slate-500">{eur(credit.amount)} event credit{credit.reversed ? " · withdrawn" : ""}</p>
    </div>
  );
}

export function CreditSummary({ credits }) {
  if (!credits?.length) return null;
  const wallet = credits.filter(c => c.destination === "wallet");
  const coupons = credits.filter(c => c.destination === "coupon");
  return (
    <div className="space-y-2" data-testid="walkin-credit-summary">
      {wallet.length > 0 && (
        <p className="text-xs text-green-800 flex items-center gap-1" data-testid="walkin-credit-wallet">
          <Wallet className="w-3.5 h-3.5" /> {eur(wallet.reduce((a, c) => a + c.amount, 0))} on-attend credit added to the buyer's wallet
        </p>
      )}
      {coupons.length > 0 && (
        <>
          <p className="text-xs text-green-800 flex items-center gap-1"><Gift className="w-3.5 h-3.5" /> Ask the guest to photograph the coupon QR — spendable at merchant stalls of this event</p>
          <div className="flex flex-wrap gap-2 justify-center">{coupons.map(c => <CouponQr key={c.ticket_id} credit={c} />)}</div>
        </>
      )}
    </div>
  );
}

export function CouponDialog({ sale, onClose }) {
  return (
    <Dialog open={!!sale} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="walkin-coupon-dialog">
        <DialogHeader><DialogTitle>Event credit coupons</DialogTitle></DialogHeader>
        {sale && <CreditSummary credits={sale.credits} />}
      </DialogContent>
    </Dialog>
  );
}
